import { API, AppConfig } from 'lib';
import React, { useState } from 'react'
import StorageService from 'utils/StorageServices/StorageServices';

const configMap = {
    Supplier: { key: 'vendor_type', value: 1, api: `${AppConfig.api_baseurl}${API.ALL_LIST_DOWNLOAD_API}` },
    Party: { key: 'vendor_type', value: 2, api: `${AppConfig.api_baseurl}${API.ALL_LIST_DOWNLOAD_API}` },
    Driver: { key: 'vendor_type', value: 3, api: `${AppConfig.api_baseurl}${API.ALL_LIST_DOWNLOAD_API}` },
    Unit: { key: 'location_point', value: 1, api: `${AppConfig.api_baseurl}${API.ALL_ADDRESSBOOK_LIST}` },
    Consignee: { key: 'location_point', value: 2, api: `${AppConfig.api_baseurl}${API.ALL_ADDRESSBOOK_LIST}` },
};

const ButtonExelDownload = (props) => {

    let { name } = props;
    const [loading, setLoading] = useState(false);
    let isToken = localStorage.getItem("token");

    const getDownloadList = async (event) => {
        event.preventDefault();
        setLoading(true)
        try {
            let selectedConfig = configMap[name];
            const payload = {
                company_id: StorageService.getCompanyId(),
                [selectedConfig.key]: selectedConfig.value
            };

            const baseUrl = `${selectedConfig.api}`;
            const response = await fetch(baseUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Token': `${isToken}`,
                },
                body: JSON.stringify(payload)
            });
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `${name}-list.xlsx`;
            document.body.appendChild(a);
            a.click();
            a.remove();
            setLoading(false);
        } catch (error) {
            setLoading(false);
        }
    }

    return (
        <div className="_rSideBtn" onClick={(e) => getDownloadList(e)}>
            <button className="_addComm_btn" disabled={loading}> {loading ? 'Loading...' : 'Download'} </button>
        </div>
    )
}

export default React.memo(ButtonExelDownload)